import { render, staticRenderFns } from "./BookConcession.vue?vue&type=template&id=00b076a4&scoped=true&"
import script from "./BookConcession.vue?vue&type=script&lang=js&"
export * from "./BookConcession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b076a4",
  null
  
)

export default component.exports